import axios from "axios";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import moment from "moment";
import { CircleLoader } from "react-spinners";

const BlacklistEdit = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [blacklist, setBlacklist] = useState();
    const [search, setSearch] = useState('');
    const [searchFilter, setFilter] = useState('company')

    const [representatives, setRepresentatives] = useState([])

    const user_id = Cookies.get('token_id')

    const test_link = "http://localhost:3000"
    const production_link = "https://apple-tree-server.vercel.app/"

    const admin = Cookies.get('token_admin');




    const getBlacklist = async () => {
        // axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
        if (admin == 'yes') {
            await axios.get(production_link + 'blacklist/')
        .then(response => {
            let blacklist_data = response.data.filter((data) => {
                    if (searchFilter === 'company') {
                        return data.company_name.toLowerCase().includes(search)
                    } else if (searchFilter === 'user listed') {
                        return (data.user_first_name + ' ' + data.user_last_name).toLowerCase().includes(search) 
                    } else if (searchFilter === 'representative') {
                        for (let index = 0; index < representatives.length; index++) {
                            const rep = representatives[index];
                            if (data.company_id === rep.company_id) {
                                if ((rep.first_name + ' ' + rep.last_name).toLowerCase().includes(search)) {
                                    return true
                                } 
                            }
                        }
                    
                    } else if (searchFilter === 'category') {
                        return (data.category).toLowerCase().includes(search) 
                    } else if (searchFilter === 'id') {
                        for (let index = 0; index < representatives.length; index++) {
                            const rep = representatives[index];
                            if (data.company_id === rep.company_id) {
                                if (rep.id_number.includes(search)) {
                                    return true
                                } 
                            }
                        }
                    } else if (searchFilter === 'company reg') {
                        return data.registration_number.toLowerCase().includes(search);
                    }
            })

            setBlacklist(blacklist_data.reverse())
        })
        } else {
            await axios.post(production_link + 'current/blacklist/', {
            user_id
        })
        .then(response => {
            let blacklist_data = response.data.filter((data) => {
                    if (searchFilter === 'company') {
                        return data.company_name.toLowerCase().includes(search)
                    } else if (searchFilter === 'user listed') {
                        return (data.user_first_name + ' ' + data.user_last_name).toLowerCase().includes(search) 
                    } else if (searchFilter === 'representative') {
                        for (let index = 0; index < representatives.length; index++) {
                            const rep = representatives[index];
                            if (data.company_id === rep.company_id) {
                                if ((rep.first_name + ' ' + rep.last_name).toLowerCase().includes(search)) {
                                    return true
                                } 
                            }
                        }
                    
                    } else if (searchFilter === 'category') {
                        return (data.category).toLowerCase().includes(search) 
                    } else if (searchFilter === 'id') {
                        for (let index = 0; index < representatives.length; index++) {
                            const rep = representatives[index];
                            if (data.company_id === rep.company_id) {
                                if (rep.id_number.includes(search)) {
                                    return true
                                } 
                            }
                        }
                    } else if (searchFilter === 'company reg') {
                        return data.registration_number.toLowerCase().includes(search);
                    }
            })

            setBlacklist(blacklist_data.reverse())
        })
        // .then(response => {
        //     console.log(response.data);
        //     let blacklist_data = response.data;
        //     setBlacklist(blacklist_data.reverse())
        // })
        }
        
    }

    useEffect(() => {
        setIsVisible(true);
        getBlacklist()
        // getRepresentatives()
    }, []);

    useEffect(() => {
        getBlacklist()
    }, [search, searchFilter]);

    const navigate = useNavigate();

    if (blacklist == null) {
        return (
            <div>
            <h4 className="text-center display-5 fst-italic text-muted">Edit Blacklist</h4>
                 
                <div style={{height:"50vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
            </div>
            
        )
    }

    return ( 
        <div>
            <h4 className="text-center display-5 fst-italic text-muted">Edit Blacklist</h4>
            <div >
                    <p className="text-success text-center fs-6 fst-italic lead d-block">admin mode</p>

                    </div>
           
                <div className="d-flex justify-content-center m-4">
                    

                <div className="btn-group w-75">
                    <select name="filter" id="" className="form-select w-25 rounded-0 rounded-start" onChange={(e) => {
                        setFilter(e.target.value)
                        }}>
                            <option value="company">Company</option>
                            <option value="user listed">Listed by</option>
                            <option value="representative">Representative</option>
                            <option value="category">Category</option>
                            <option value="id">ID number</option>
                            <option value="company reg">Company registration number</option>
                    </select>
                    <input type="text" className="form-control w-75 rounded-0 rounded-end" placeholder={`Search by ${searchFilter}`} onChange={(e) => {
                        setSearch(e.target.value.toLowerCase());
                    }}></input>
                </div>
                
                
            </div>
            
            
            <div className="d-flex flex-column justify-content-center">
                <div className="container w-75">
                    <p className="text-muted text-end blockquote-footer">{blacklist.length} results</p>
                </div>
               {
                blacklist.map((item) => {
                    let blacklist_date = item.blacklist_date;
                    const new_date = moment(blacklist_date).format('Do MMM YYYY')
                    return (
                        <div className={`container notification w-75 py-3 my-3 ${isVisible ? 'fade-in-left' : ''}`} onClick={() => {
                            navigate(`/edit/blacklist/${item.reference_number}`)
                        }}>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-2 mb-0">Company name:  {item.company_name}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listing reason:  {item.category}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Representative(s):  
                                        {representatives.map((rep) => {
                                            if (item.company_id === rep.company_id) {
                                                return <span>  {rep.first_name} {rep.last_name},  </span>
                                            }
                                        })}</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listed by: {item.user_company} ({item.user_first_name} {item.user_last_name} )</p>
                            <p className="blacklist-text fst-italic fs-6 ms-3 mt-0 mb-0">Listing date: {new_date}</p>
                        </div>
                )})
            } 
            </div>
        </div>
        
        
     );
}
 
export default BlacklistEdit;